import { env } from "../libs/utils/env";

export const APP_PRODUCT_NAME = env.string(
    process.env.REACT_APP_PRODUCT_NAME,
    "VIDA LEY EMPLEADOS"
);
